import React from 'react';
import { ReactComponent as DownloadIcon } from "assets/img/svg/downloadIcon.svg";
import { exportToExcel } from 'views/pages/manage/unAssigned/collectPayment/selectCharges/downloadChargesData/downloadExcel/exportToExcel';
import { getSubmissionStatusExcelDetails } from './utils';





const DownloadSubmissionStatusExcel = ({
    processId,
    fileName,
    status,
    transferType
}) => {

    const headers = [
    { label: 'Business Area', key: 'outBusinessArea' },
    { label: 'PSID', key: 'outPsid' },
    { label: 'Application Id', key: 'outApplicationId' },
    ...(!(transferType.includes("CRCG")|| transferType.includes("STCG"))?[{ label: 'Trin Business Area', key: 'inBusinessArea' },
    { label: 'Trin Cashier Office', key: 'inCashierOffice' }]:[]),
    { label: 'Trin Course ID', key: 'inCourseId' },
    { label: 'Trin Term', key: 'inTermValue' },
    { label: 'Trin Stream', key: 'inStream' },
    // { label: 'Acknowledgement ID', key: 'ackId' },// it will not be there , discussed with mallika and khodani
    { label: 'Reason of transfer', key: 'reasonOfTransfer'},
    { label: 'Remarks', key: 'remarks'},
    { label: 'Reference Id', key: 'referenceId'},
    { label: 'Status', key: 'status'},
    { label: 'Failure Reason', key: 'failureReason'},
]

    const downloadFile = async () => {
        try {
            const res = await getSubmissionStatusExcelDetails(processId);
            exportToExcel(res, headers, fileName)
        }
        catch (err) {
            console.log(err)
        }
    }



    return (
        <div>
            {status !== 'IN_PROGRESS' && <DownloadIcon className=' ml-2 cursor' onClick={() => downloadFile()} />}
        </div>
    );

}

export default DownloadSubmissionStatusExcel;